import * as Type from '../actions/Product/ProductActionTypes';
const initialState = [];
export default function productReducer(state=initialState,action){
    const { type, payload } = action;
    //console.log(payload);
    switch(type){
    case Type.CREATE_PRODUCT:
        return [...state,payload];
    case Type.LOAD_PRODUCT_SUCCESS:
        console.log('LOAD PRODUCT SUCCESS',payload);
        return payload.products;
    case Type.UPDATE_PRODUCT:
        return state.map((prod) => {
            if (prod.id === payload.id) {
                payload.product;
                
            } else {
                prod;
            }
        });
    case Type.DELETE_PRODUCT:
        return state.filter(({ id }) => id !== payload.id);
    case Type.GET_PRODUCT_BY_QUANTITY:
        return state.filter(({ qty }) => qty !== payload);
    case Type.GET_PRODUCT_BY_NAME:
        return state.filter(({ name }) => name !== payload);
    case Type.READ_PRODUCT:
        return payload;
    default:
        return state;
    }
}